import { useQueryClient } from "react-query";
import { useAxiosMutation } from "hooks";
import { axiosChartInstance } from "config";

function useDeleteVitalCheck(encounterId: string) {
  const queryClient = useQueryClient();
  return useAxiosMutation(
    ["deleteVitalCheck"],
    (vitalCheckId: string) =>
      axiosChartInstance.delete(
        `v1/Vitals/vitals/${encounterId}/vital-check/${vitalCheckId}`
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["vitals"]);
        queryClient.invalidateQueries([
          "chartApplicationHardStops",
          { encounterId, chartType: "Triage" },
        ]);
        queryClient.refetchQueries({
          queryKey: [
            "chartApplicationHardStops",
            { encounterId, chartType: "Triage" },
          ],
          active: false,
          inactive: true,
          predicate: (query) => query.getObserversCount() > 0,
        });
        queryClient.invalidateQueries(["chartPatientCard", { encounterId }]);
      },
    }
  );
}

export { useDeleteVitalCheck };
